<template>
	<div class="canvas">
		<div class="container" >
			<div class="panel panel-default">
				<div class="panel-body">
					<div class="page-header">
						<div class="row">
							<div class="title-content">
                <div class="title-icon">
                  <i :class="icone" aria-hidden="true"></i>
                </div>
                <div class="title-text">
								  <h4>{{ titulo }}</h4>
                </div>
                <div class="title-logo">
                  <img :src="require('../../assets/' + imagemTexto)" v-show="logoComTexto">
                  <img :src="require('../../assets/' + imagem)" v-show="!logoComTexto">
                </div>
							</div>
							<div class="clearfix"></div>
						</div>
					</div>
					<div>{{ texto }} </div>
				</div>
        <slot></slot>
			</div>
		</div>
	</div>
</template>

<script >
export default {
	name: 'construcao',
	computed: {
		logoComTexto () {
			const bodyWidth = document.body.clientWidth
			return bodyWidth >= 520 ? true : false
		}
	},
	props: {
		titulo: {
			required: true,
			type: String
		},
		icone: {
			required: true,
			type: String
		},
		imagemTexto: {
			required: true,
			type: String
		},
		imagem: {
			required: true,
			type: String
		},
		texto: {
			required: true,
			type: String
		}
	},
	mounted() {
		const bodyHeight = document.body.clientHeight - 109
		document.querySelector('.canvas').style.height = `${bodyHeight}px`
		window.scrollTo(0, 0)
	}
}
</script>

<style scoped>
img{
	max-height: 45px;
}
.canvas {
	display: flex;
}
.container {
	display: flex;
}
.panel-default{
	max-width: 600px;
	margin: auto;
	align-content: center;
}
.page-header{
	margin-top: 0;
	padding: 5px 15px;
}

.title-content {
  display: grid;
  grid-template-columns: min-content auto 70px;
  margin-top: -10px;
}
.title-icon {
  display: flex;
  align-items: center;
  color: #a1be4d;
  font-size: 2.3em;
}
.title-text {
  padding: 0 10px;
}
.title-logo {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media screen and (min-width: 520px) {
	img {
		max-height: 38px;
	}
  .title-content {
  display: grid;
  grid-template-columns: min-content auto 115px;
  margin-top: -10px;
}
}

</style>



// WEBPACK FOOTER //
// index.vue?282409f0